import apiClient from "./Environment";

export default {
  getHighlights(data) {
    return apiClient.get(
      "/highlights?hotel_id=" +
        data.hotel_id +
        "&extraction_id=" +
        data.extraction_id +
        "&revenue_extraction_id=" +
        (data.revenue_extraction_id || 0)
    );
  },
  getHighlightsInfo(data) {
    return apiClient.post("/highlights-info", {
      hotel_id: data.hotel_id
    });
  }
};
